import React from 'react';
import { useContext } from 'react';
import { UserContext } from '../../context/UserContext';
import {
  Layout,
  Row,
  Col,
  Input,
  Dropdown,
  Avatar,
  Space,
  Badge,
  Button,
} from 'antd';
import {
  BellOutlined,
  MailOutlined,
  DownOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { Icon } from '@iconify/react';
import { useNavigate } from 'react-router-dom';
import useLogout from '../../hooks/useLogout';

const { Header } = Layout;

const LayoutHeader = () => {
  const navigate = useNavigate();
  const logout = useLogout();
  const { user } = useContext(UserContext);

  const menuItems = [
    {
      key: 'profile',
      label: 'My Profile',
      icon: <Icon icon="mdi:user-outline" />,
      onClick: () => navigate('/landlord/profile'),
    },
    {
      key: 'settings',
      label: 'Settings',
      icon: <Icon icon="mdi:settings-outline" />,
      onClick: () => navigate('/landlord/settings'),
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      label: 'Logout',
      icon: <Icon icon="icon-park-outline:logout" />,
      onClick: logout,
    },
  ];

  return (
    <Header
      style={{
        background: '#fff',
        padding: '0 24px',
        height: 72,
        display: 'flex',
        alignItems: 'center',
        borderBottom: '1px solid #f0f0f0',
      }}
    >
      <Row justify="space-between" align="middle" style={{ width: '100%' }}>
        <Col flex="1">
          <Input
            placeholder="Search everything"
            style={{ width: '100%', maxWidth: 400, borderRadius: 8 }}
          />
        </Col>

        <Col>
          <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Badge count={3}>
                <Button
                  type="text"
                  icon={<BellOutlined style={{ fontSize: 20 }} />}
                />
              </Badge>
            </div>

            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Badge count={2}>
                <Button
                  type="text"
                  icon={<MailOutlined style={{ fontSize: 20 }} />}
                />
              </Badge>
            </div>

            <Dropdown
              menu={{
                items: menuItems,
                onClick: ({ key }) => {
                  const item = menuItems.find((i) => i.key === key);
                  if (item && item.onClick) item.onClick();
                },
              }}
              placement="bottomRight"
              trigger={['click']}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                }}
              >
                <Avatar
                  size={40}
                  src={user?.profileImage || null}
                  style={{
                    backgroundColor: user?.profileImage
                      ? 'transparent'
                      : '#9701fc',
                  }}
                  icon={!user?.profileImage ? <UserOutlined /> : null}
                >
                  {!user?.profileImage &&
                    user?.firstname?.[0]?.toUpperCase() +
                      user?.lastname?.[0]?.toUpperCase()}
                </Avatar>
                <span style={{ fontWeight: 600, marginLeft: 8 }}>
                  {user?.username}
                </span>
                <DownOutlined style={{ marginLeft: 4 }} />
              </div>
            </Dropdown>
          </div>
        </Col>
      </Row>
    </Header>
  );
};

export default LayoutHeader;
